import { render, staticRenderFns } from "./NeedCommon.vue?vue&type=template&id=4d9bab40&scoped=true&"
import script from "./NeedCommon.vue?vue&type=script&setup=true&lang=js&"
export * from "./NeedCommon.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9bab40",
  null
  
)

export default component.exports